<template>
  <section class="customize">
    <div class="container">
      <div
        class="right aos-init aos-animate"
        data-aos="fade-left"
        data-aos-duration="2000"
      >
        <h2>Customizable insurance that fits your needs and budget</h2>
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="bullet"
        >
          <tbody>
            <tr>
              <td class="bulleticon" width="19%" valign="top">
                <img
                  loading="lazy"
                  :src="require('@/assets/images/icon7.svg')"
                  width="115"
                  height="114"
                  alt="Caption"
                />
              </td>

              <td>
                <h3>
                  <strong>For parents sending kids off to college.</strong>
                </h3>
                <p>
                  Purchase coverage on their behalf. Rest easy knowing that if
                  damage occurs, your student is covered in their dorm or other
                  student housing.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!------------->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="bullet"
        >
          <tbody>
            <tr>
              <td class="bulleticon" width="19%" valign="top">
                <img
                  loading="lazy"
                  :src="require('@/assets/images/icon8.svg')"
                  width="115"
                  height="114"
                  alt="Caption"
                />
              </td>

              <td>
                <h3>Add a roommate!</h3>
                <p>
                  A roommate can be added to your Renters Insurance policy – at
                  no additional cost!
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!------------->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="bullet"
        >
          <tbody>
            <tr>
              <td class="bulleticon" width="19%" valign="top">
                <img
                  loading="lazy"
                  :src="require('@/assets/images/icon9.svg')"
                  width="115"
                  height="114"
                  alt="Caption"
                />
              </td>

              <td>
                <h3>
                  <strong>If you move, our coverage can too! </strong>
                </h3>
                <p>
                  Even if you are studying abroad, you’re covered! Wherever you
                  rent, your Renters Insurance coverage goes with you.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!------------->
      </div>
      <div style="clear: both"></div>
    </div>
  </section>
</template>
